/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.5.3",
  "gitBuildTime": "2026-03-23T14:51:19.973Z",
  "gitBuildVersion": "2.5.3",
  "gitCommitId": "53732c9",
  "gitCommitIdFull": "53732c9d04298bd6cc4f319ea9645193c959f529",
  "gitCommitTime": "2026-03-23T14:49:34.000Z",
  "version": "2.5.3-2026-03-23T14:49:34.000Z-(53732c9)"
};
